module.exports = __webpack_public_path__ + "img/canvasMenu3.9ee82562.svg";